module.exports = __webpack_public_path__ + "static/img/admin_dnsd.0b99656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin_dnsd.png
// module id = NQat
// module chunks = 1